var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.91218 39.9998L25.7726 39.9999C31.7202 40 35.7162 36 35.7626 30.0001L35.9172 10.0002C35.9635 4.00022 32.0294 0.000221056 26.0817 0.000179608L10.2213 6.908e-05C4.27369 2.7632e-05 0.277678 3.99998 0.231305 9.99994L0.0767272 29.9998C0.0303539 35.9998 3.96453 39.9998 9.91218 39.9998Z",
    fill: "#FFF6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9609 11.9996C22.7987 6.41957 13.4212 6.41951 7.15286 11.9994C6.87329 12.2594 6.81073 12.6594 7.00666 12.9594L11.2745 19.9595C11.3921 20.1395 11.5892 20.2795 11.7873 20.2995C12.0051 20.3395 12.2238 20.2595 12.3835 20.1195C15.5976 17.2595 20.3953 17.2596 23.5651 20.1196C23.703 20.2396 23.8809 20.2996 24.0594 20.2996C24.099 20.2996 24.1387 20.2996 24.1585 20.2996C24.3769 20.2596 24.5761 20.1396 24.6766 19.9596L29.0526 12.9596C29.2929 12.6596 29.2365 12.2596 28.9609 11.9996Z",
    fill: "#FFF6F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.a0c199b412ace8c6c5258af4ef683597.svg";
export { ForwardRef as ReactComponent };